import { last, get } from 'lodash'
import { toObject } from 'utils/parameterGroups'
import { asNumber } from 'utils/tealium'

// even though multiselection is not possible, we're formatting the only selection as a list
const createMultiSelectionList = (ad, key) => {
  const lastId = last(ad[key])
  return [{ localId: lastId.id }]
}

const pathFormatter = (item) => (item ? ` > ${item}` : '')

const adData = (ad) => {
  const { general, car, residence } = toObject(ad.parameterGroups)

  let premiumFilter = ''

  if (get(general, 'insurance.value') === '1') {
    premiumFilter = 'BBF'
  } else if (get(ad, 'featuredPlacements', []).some((itr) => itr.id === 'premium_warranty')) {
    premiumFilter = 'Premium Garanti'
  }

  const _objectRegionPath = `${((item) => (item ? `${item}` : ''))(get(ad, 'location.0.name'))}${
    // sub category group
    pathFormatter(get(ad, 'location.1.name'))
  }${
    // category
    pathFormatter(get(ad, 'location.2.name'))
  }`

  const _objectCategoryPath = `${
    // sub category group
    get(ad, 'category.0.name', '')
  }${
    // sub category group
    pathFormatter(get(ad, 'category.1.name'))
  }${
    // category
    pathFormatter(get(ad, 'category.2.name'))
  }${
    // car brand
    pathFormatter(get(car, 'cxMake.value'))
  }${
    // car brand series
    pathFormatter(get(car, 'level1.value'))
  }${
    // car model
    pathFormatter(get(car, 'level2.value'))
  }${
    // country of residence
    pathFormatter(get(residence, 'country.value'))
  }`

  return {
    // item info

    objectPublisherType: ad.advertiser.type,
    objectPublisherName: ad.advertiser.name,
    objectPublisherId: get(ad, 'store.storeId', ad.advertiser.accountId),
    objectTitle: ad.subject,
    objectListId: asNumber(ad.listId),
    objectItemId: asNumber(ad.adId),
    objectItemType: ad.type,
    objectPublishDate: ad.listTime,
    objectNumPictures: get(ad, 'images.length', 0),
    objectPrice: get(ad, 'price.value'),
    objectStatus: ad.adStatus,
    objectZipcode: ad.zipcode,

    objectRegionPath: _objectRegionPath !== '' ? _objectRegionPath.replace(/,/g, '') : undefined,

    // category

    objectCategoryPath:
      _objectCategoryPath !== '' ? _objectCategoryPath.replace(/,/g, '') : undefined,
    objectCategories: createMultiSelectionList(ad, 'category'),

    // premium filter
    objectPremiumBadge: premiumFilter,

    // info from bytbil
    objectCarCxBodyType: get(car, 'cxBodyType.value'),
    objectCarCxCo2EmissionMixedDriving: get(car, 'cxCo2EmissionMixedDriving.value'),
    objectCarCxCo2EmissionMixedDrivingFiltered: get(car, 'cxCo2EmissionMixedDrivingFiltered.value'),
    objectCarCxCo2EmissionMixedDrivingInd: get(car, 'cxCo2EmissionMixedDrivingInd.value'),
    objectCarCxColor: get(car, 'cxColor.value'),
    objectCarCxComputedModelYear: get(car, 'cxComputedModelYear.value'),
    objectCarCxDriveWheels: get(car, 'cxDriveWheels.value'),
    objectCarCxEnginePower: asNumber(get(car, 'cxEnginePower.value')),
    objectCarCxEngineSize: asNumber(get(car, 'cxEngineSize.value')),
    objectCarCxFirstTimeInTraffic: get(car, 'cxFirstTimeInTraffic.value'),
    objectCarCxGearbox: get(car, 'cxGearbox.value'),
    objectCarCxBrand: get(car, 'cxMake.value'),
    objectCarCxModel: get(car, 'cxModel.value'),
    objectCarCxModelYear: asNumber(get(car, 'cxModelYear.value')),
    objectCarChassisType: get(car, 'carChassisType.value'),
    // info from AI
    objectCarFuel: get(general, 'fuel.value'),
    objectCarTransmission: get(general, 'gearbox.value'),
    objectCarMileage: get(general, 'mileage.value'),
    objectCarRegdate: asNumber(get(general, 'regdate.value')),
    // residence
    objectRealEstateRooms: get(residence, 'rooms.value'),
    objectRealEstateSurfaceUnits: get(residence, 'size.suffix'),
    objectRealEstateSurface: get(residence, 'size.value'),
    objectRealEstateCapacity: get(residence, 'capacity.value'), // might not be in use
    objectRealEstateIsFurnished: get(residence, 'furnished.value'),
    objectRealEstateEnergyClass: get(residence, 'energyClass.value'),
    objectRealEstateGasEmission: get(residence, 'gasEmission.value'), // might not be in use
    // clothes
    objectClothingItems: get(ad, 'subAds'),
    // Blocket Payment
    objectBlocketPayment: get(ad, 'blocketBetalning') ? 1 : undefined,
  }
}

export default adData
